import { render, staticRenderFns } from "./AboutBanner.vue?vue&type=template&id=a13b01ee&scoped=true"
import script from "./AboutBanner.vue?vue&type=script&lang=js"
export * from "./AboutBanner.vue?vue&type=script&lang=js"
import style0 from "./AboutBanner.vue?vue&type=style&index=0&id=a13b01ee&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a13b01ee",
  null
  
)

export default component.exports